import { render, staticRenderFns } from "./MasiveLoad.vue?vue&type=template&id=1c1e6edf&lang=pug&"
import script from "./MasiveLoad.vue?vue&type=script&lang=js&"
export * from "./MasiveLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports